import React, { Component } from "react";
import { images } from "../../settings";
import { DelayLink } from "../../components";
import {
  BrowserRouter as Router,
  Link
} from "react-router-dom";

import './DropDown.scss';

class DropDown extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dropAberto: false
    }
  }
  toggleDropDown = () => {
    this.setState({
      dropAberto: !this.state.dropAberto
    })
  }
  render() {
    return(
      <div className={`drop-down ${this.state.dropAberto ? 'drop-down--aberto' : ''}`}>
        <button className="drop-down__botao" onClick={this.toggleDropDown}>
          <span className="drop-down__titulo">{this.props.titulo}</span>
          <img className="drop-down__icone" src={images.icons.shape_next_dropdown} alt="Ícone" />
        </button>
        { this.state.dropAberto &&
          <ul className="lista-drop-down">
            { this.props.dados.map( (res, index) => {
              return (
              <li key={index}>
                <span className="lista-drop-down__gri">{res.gri}</span>
                <div>
                  { (res.link && typeof res.link === 'string') &&  <DelayLink className="lista-drop-down__link text_link text_link--dark-gray" to={res.link}>{res.titulo}</DelayLink> }
                  { (!res.link) && <p className="lista-drop-down__link">{res.titulo}</p> }
                  { (res.link && (typeof res.link === 'object' || typeof res.link === 'array')) && <p className="lista-drop-down__link">{res.titulo}</p> }
                  { res.descricao && <p className="lista-drop-down__descricao">{res.descricao}</p> }

                  {
                    typeof res.link === 'object' &&
                    <div className="lista-drop-down__sublinks">
                      <header>Confira em</header>
                      <div className="lista-drop-down__sublinks__body">
                        {
                          res.link.map((item, u) => {
                            return (
                              <DelayLink className="lista-drop-down__sublink text_link text_link--dark-blue" to={item}>#{u+1}</DelayLink>
                            )
                          })
                        }
                      </div>
                    </div>
                  }

                </div>
              </li>
            )})}
          </ul>
        }
        { this.state.dropAberto && this.props.respostaGeral &&
          <p className="resposta-geral-sumario-gri">{this.props.respostaGeral}</p>
        }
      </div>
    )
  }
}

export { DropDown }